import { CartItemChangeType, ProductAdViewModel, ProductListViewModel } from '@/types/api'

import { DataLayerProps } from '@/app/(home-page)/type'

export interface PricingInterface {
    basePrice?: number
    effectivePrice?: number
    discountPercent?: number
}

export enum PostCartTypes {
    Increament = 'inc',
    Decreament = 'dec',
}

export interface PricingType {
    basePrice?: number
    effectivePrice?: number
    discountPercent?: number
}

export interface ColorType {
    name: string
    hex?: string
    image?: string
    id: string
}
export interface BasketCardProps {
    id: string
    atpId: string
    slug: string
    pricingProps: PricingType
    brand: string
    name: string
    image: string
    isLazy?: boolean
    maxLimited: number
    initialCount: number
    color: ColorType
    isGift?: boolean
    changeType?: CartItemChangeType
    shipBySeller?: boolean
    flags?: string | null
    weightUnit?: string | null
    weightValue?: number | null
}

export interface PLPCardProps {
    slug: string
    pricingProps: PricingType
    brand: string
    name: string
    image: string
    isLazy?: boolean
    colorsCount: number
    flags?: string[]
    hasGift?: boolean
    isSalable: boolean
    indexInSinglePage: number
    id: string
    ad?: ProductAdViewModel
    indexInAllPages: number
}

export interface PDPCardProps {
    id: string
    atpId?: string
    itemProposalId?: string
    slug: string
    pricingProps: PricingType
    brand: string
    name: string
    image: string
    isLazy?: boolean
    showDirectAddToCart?: boolean
    type: 'horizontal' | 'vertical'
    isSalable: boolean
    className?: string
    count?: number
    index?: number
    preventNavigation?: boolean
}

export interface HomePageCardProps extends DataLayerProps {
    id: string
    slug: string
    pricingProps: PricingType
    brand: string
    name: string
    image: string
    isLazy?: boolean
    isSalable: boolean
    className?: string
    index?: number
    type: 'pink-box' | 'product-list'
    itemId?: string
    showNumber?: boolean
}

export interface FavoriteCardProps {
    pricingProps: PricingType
    id: string
    slug: string
    brand: string
    name: string
    image: string
    isLazy?: boolean
    isSalable?: boolean
    onWishlistDelete: (id: ProductListViewModel['id']) => void
    product: ProductListViewModel
}

export enum GridTypes {
    PLP = 'plp',
    Favorite = 'favorite',
}

export interface StoryEventExtraData {
    componentId: string
    sortKey: string
    itemId: string
}
